export default __webpack_public_path__ + "static/media/drayage_chassis.6e8f77f8.JPG";